/**
 * Client-side postcode token normalization (aligned with backend delivery_postcodes.utils).
 */
export function normalizePostcodeToken(raw: string): string | null {
  const s = raw
    .trim()
    .split(/\s+/)
    .join(' ')
    .toUpperCase();
  if (!s) {
    return null;
  }
  if (!/^[A-Z0-9 ]+$/.test(s)) {
    return null;
  }
  if (s.length > 32) {
    return null;
  }
  return s;
}

/** Split pasted or typed buffer into raw tokens (before normalization). */
export function splitPostcodeInput(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((t) => t.trim())
    .filter(Boolean);
}
